import * as React from 'react';
import {styled} from '@mui/material/styles';
import List from '@mui/material/List';
import Divider from '@mui/material/Divider';
import IconButton from '@mui/material/IconButton';
import ChevronLeftIcon from '@mui/icons-material/ChevronLeft';
import ChevronRightIcon from '@mui/icons-material/ChevronRight';
import ListItem from '@mui/material/ListItem';
import ListItemButton from '@mui/material/ListItemButton';
import ListItemIcon from '@mui/material/ListItemIcon';
import AnalyticsOutlinedIcon from '@mui/icons-material/AnalyticsOutlined';
import DeveloperBoardOutlinedIcon from '@mui/icons-material/DeveloperBoardOutlined';
import LogoutIcon from '@mui/icons-material/Logout';
import {
    Card,
    CardContent,
    Dialog, DialogActions, DialogContent,
    DialogTitle,
    FormControl, FormControlLabel,
    FormGroup, FormLabel,
    Grid,  MenuItem, Radio, RadioGroup, Select, Slide,
    Stack, Switch,
    Tooltip
} from "@mui/material";
import Button from "@mui/material/Button";
import Box from "@mui/material/Box";
import {useContext, useEffect, useState} from "react";
import HelpOutlineOutlinedIcon from "@mui/icons-material/HelpOutlineOutlined";
import {Person2Outlined} from "@mui/icons-material";
import {UserContext} from "../../../Context/UserContext";
import Typography from "@mui/material/Typography";
import LinkIcon from "@mui/icons-material/Link";
import {useTheme} from '@mui/material/styles';
import {useNavigate} from "react-router";
import {TokenContext} from "../../../Context/TokenContext";
import {TranslationContext} from "../../../Context/TranslationContext";
import {useTranslation} from "../../../hooks/useTranslation";
import {usePermissions} from "../../../hooks/usePermissions";
import ShoppingCartOutlinedIcon from '@mui/icons-material/ShoppingCartOutlined';
import RequestQuoteOutlinedIcon from '@mui/icons-material/RequestQuoteOutlined';
import { getQuotes } from '../../../Utils/quotesApi';
import SupportAgentOutlinedIcon from '@mui/icons-material/SupportAgentOutlined';
import MenuBookIcon from '@mui/icons-material/MenuBook';
import BusinessIcon from '@mui/icons-material/Business';
import ReceiptLongIcon from '@mui/icons-material/ReceiptLong';
import WebIcon from '@mui/icons-material/Web';

const Transition = React.forwardRef(function Transition(props, ref) {
    return <Slide direction="down" ref={ref} {...props} />;
});

// Les noms de langue s'affichent dans leur propre langue (endonyme), peu importe
// la langue active de l'interface — convention standard des sélecteurs de langue.
const LANGUAGE_LABELS = {
    fr: 'Français',
    en: 'English',
    es: 'Español',
};

export default function SidebarContent(props) {
    const {mode, setMode} = useState();

    const navigate = useNavigate();

    const theme = useTheme();
    const _userContext = useContext(UserContext)
    const _tokenContext = useContext(TokenContext)
    const {currentLanguage, setLanguage, availableLanguages} = useContext(TranslationContext)
    const { isCompanyUser, canEditCompanyInfo, canManageUsers } = usePermissions()

    const [openDialogInfo, setOpenDialogInfo] = React.useState(false);
    const [openDialogDisconnect, setOpenDialogDisconnect] = React.useState(false);

    // Commandes/devis temporairement désactivés : le backend correspondant
    // n'est pas encore en prod et l'appel générait des erreurs au chargement.
    // "Mes devis" only appears once an admin has issued at least one quote —
    // has_quotes covers pending devis too, not just decided ones (see
    // quotesApi.js). No existing precedent for data-driven nav items, so
    // this is fetched locally here rather than added to a shared context.
    const [hasQuotes, setHasQuotes] = useState(false);
    // useEffect(() => {
    //     if (!_tokenContext.isAuthenticated) return;
    //     getQuotes()
    //         .then(({ has_quotes }) => setHasQuotes(!!has_quotes))
    //         .catch(() => {});
    //     // eslint-disable-next-line react-hooks/exhaustive-deps
    // }, [_tokenContext.isAuthenticated]);

    const linkNav = [
        {
            name: 'menu.dashboard',
            link: '/',
            icon: <AnalyticsOutlinedIcon sx={{color: "#FF7233"}}/>
        },
        // {
        //     name: 'menu.shop',
        //     link: '/programs',
        //     icon: <ShoppingCartOutlinedIcon sx={{color: "#FF7233"}}/>
        // },
        {
            name: 'menu.website',
            link: '/site-internet',
            icon: <WebIcon sx={{color: "#FF7233"}}/>
        },
        {
            name: 'menu.programs',
            link: '/programs',
            icon: <DeveloperBoardOutlinedIcon sx={{color: "#FF7233"}}/>
        },
        // {
        //     name: 'menu.orders',
        //     link: '/orders',
        //     icon: <ShoppingCartOutlinedIcon sx={{color: "#FF7233"}}/>
        // },
        // ...(hasQuotes ? [{
        //     name: 'menu.quotes',
        //     link: '/quotes',
        //     icon: <RequestQuoteOutlinedIcon sx={{color: "#FF7233"}}/>
        // }] : []),
        // {
        //     name: 'menu.invoices',
        //     link: '/invoices',
        //     icon: <ReceiptLongIcon sx={{color: "#FF7233"}}/>
        // },
        {
            name: 'menu.support',
            link: '/tickets',
            icon: <SupportAgentOutlinedIcon sx={{color: "#FF7233"}}/>
        },
        // {
        //     name: 'menu.documentation',
        //     link: '/',
        //     icon: <MenuBookIcon sx={{color: "#FF7233"}}/>
        // },
    ]


    const DrawerHeader = styled('div')(({theme}) => ({
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        padding: theme.spacing(0, 2),
        width: "100%",

        // necessary for content to be below app bar
        ...theme.mixins.toolbar
    }));

    const toggleDrawer = (open) => () => {
        props.setIsOpen(open);
    };

    const t = useTranslation('Sidebar.json')
    const tCommon = useTranslation('Common.json')
    const handleClickOpenAccount = () => {
        navigate('/account');
    };

    const handleClickOpenCompany = () => {
        navigate('/account?tab=entreprise');
    };

    const handleClickOpenDialogInfo = () => {
        setOpenDialogInfo(true);
    };

    const handleCloseDialogInfo = () => {
        setOpenDialogInfo(false);
    };

    const handleCloseDialogDisconnect = () => {
        setOpenDialogDisconnect(false);
    };

    console.log(theme.palette.mode)

    return (
        <>
            <Stack
                direction="column"
                justifyContent="space-between"
                // alignItems="center"
                height={'100%'}
                width={'100%'}
                spacing={0}
                sx={{
                    margin: 0,
                    padding: 0
                }}
            >

                <Box
                    sx={{
                        margin: 0,
                        padding: 0
                    }}
                >
                    <DrawerHeader>


                        {
                            props.isOpen && (
                                <>
                                    <h2 style={{color: "#FF7233"}}>{t('menu.title')}</h2>
                                    <IconButton
                                        onClick={toggleDrawer(false)}>
                                        <ChevronLeftIcon/>
                                    </IconButton>
                                </>
                            )
                        }

                        {
                            !props.isOpen && (
                                <IconButton
                                    onClick={toggleDrawer(true)}>
                                    <ChevronRightIcon/>
                                </IconButton>
                            )
                        }
                    </DrawerHeader>
                    <Divider style={{width: props.width}}/>
                    <List>
                        {linkNav.map((nav) => (
                            <ListItem disablePadding sx={{display: 'block'}}
                                      onClick={() => {
                                          if (nav.action) nav.action();
                                          else navigate(nav.link);
                                      }}
                            >
                                <Tooltip title={props.isOpen ? '' : t(nav.name)} placement="left">
                                    <ListItemButton
                                        sx={{
                                            minHeight: 48,
                                            justifyContent: props.isOpen ? 'initial' : 'center',
                                            px: 2.5,
                                        }}
                                    >
                                        <ListItemIcon
                                            sx={{
                                                minWidth: 0,
                                                mr: props.isOpen ? 3 : 'auto',
                                                justifyContent: 'center',
                                            }}
                                        >
                                            {nav.icon}
                                        </ListItemIcon>
                                        <Typography sx={{
                                            display: props.isOpen ? 'initial' : 'none',
                                        }} color={`sidebar.${theme.palette.mode}`}>
                                            {t(nav.name)}
                                        </Typography>
                                        {/*<ListItemText*/}
                                        {/*    color={`sidebar.${theme.palette.mode}`}*/}
                                        {/*    primary={t(nav.name)}*/}
                                        {/*              sx={{*/}
                                        {/*                  opacity: props.isOpen ? 1 : 0,*/}
                                        {/*}}/>*/}
                                    </ListItemButton>
                                </Tooltip>
                            </ListItem>
                        ))}
                    </List>
                </Box>
                <Stack>

                    <Box>
                        <Divider/>
                        <Grid
                            container
                            direction="row"
                            justifyContent="space-around"
                            alignItems="center"
                        >
                            <Grid item size={{xs:12, md:(props.isOpen ? (isCompanyUser && (canEditCompanyInfo || canManageUsers) ? 4 : 6) : 12)}} textAlign={'center'}>
                                <Tooltip title={props.isOpen ? '' : t("sidebar.account")} placement="left">
                                    <IconButton aria-label="Person2Outlined" onClick={handleClickOpenAccount}
                                                sx={{
                                                    width: '100%',
                                                    borderRadius: 0,
                                                    mr: props.isOpen ? 3 : 'auto',
                                                    justifyContent: 'center',
                                                    color: "#FF7233"
                                                }}

                                    >

                                        <Stack
                                            direction="column"
                                            justifyContent="center"
                                            alignItems="center"

                                        >

                                            <Person2Outlined/>
                                            {
                                                props.isOpen && (<Typography color={`sidebar.${theme.palette.mode}`}>
                                                    {t("sidebar.account")}
                                                </Typography>)
                                            }
                                        </Stack>
                                    </IconButton>
                                </Tooltip>
                            </Grid>
                            {isCompanyUser && (canEditCompanyInfo || canManageUsers) && (
                                <Grid item size={{xs:12, md:(props.isOpen?4:12)}} textAlign={'center'}>
                                    <Tooltip title={props.isOpen ? '' : t("sidebar.company")} placement="left">
                                        <IconButton aria-label="Business" onClick={handleClickOpenCompany}
                                                    sx={{
                                                        width: '100%',
                                                        borderRadius: 0,
                                                        mr: props.isOpen ? 3 : 'auto',
                                                        justifyContent: 'center',
                                                        color: "#FF7233"
                                                    }}
                                        >
                                            <Stack
                                                direction="column"
                                                justifyContent="center"
                                                alignItems="center"
                                            >
                                                <BusinessIcon/>
                                                {
                                                    props.isOpen && (<Typography color={`sidebar.${theme.palette.mode}`}>
                                                        {t("sidebar.company")}
                                                    </Typography>)
                                                }
                                            </Stack>
                                        </IconButton>
                                    </Tooltip>
                                </Grid>
                            )}
                            <Grid item size={{xs:12, md:(props.isOpen ? (isCompanyUser && (canEditCompanyInfo || canManageUsers) ? 4 : 6) : 12)}} textAlign={'center'}>
                                <Tooltip title={props.isOpen ? '' : t("sidebar.about")} placement="left">
                                    <IconButton aria-label="Person2Outlined" onClick={handleClickOpenDialogInfo}
                                                sx={{
                                                    width: '100%',
                                                    borderRadius: 0,
                                                    mr: props.isOpen ? 3 : 'auto',
                                                    justifyContent: 'center',
                                                    color: "#FF7233"
                                                }}

                                    >

                                        <Stack
                                            direction="column"
                                            justifyContent="center"
                                            alignItems="center"

                                        >

                                            <HelpOutlineOutlinedIcon/>
                                            {
                                                props.isOpen && (<Typography color={`sidebar.${theme.palette.mode}`}>
                                                    {t("sidebar.about")}
                                                </Typography>)
                                            }
                                        </Stack>
                                    </IconButton>
                                </Tooltip>
                            </Grid>
                        </Grid>
                        <Divider/>

                        <Tooltip title={props.isOpen ? '' : t("sidebar.account.disconnected")} placement="left">
                            <IconButton aria-label="Logout"
                                        sx={{
                                            width: '100%',
                                            borderRadius: 0,
                                            mr: props.isOpen ? 3 : 'auto',
                                            justifyContent: 'center',
                                            color: "#FF7233"
                                        }}
                                        onClick={() => {
                                            setOpenDialogDisconnect(true)
                                        }}
                            >
                                <Stack
                                    direction="column"
                                    justifyContent="center"
                                    alignItems="center"

                                >

                                    <LogoutIcon/>
                                    {
                                        props.isOpen && (<Typography color={`sidebar.${theme.palette.mode}`}>
                                            {t("sidebar.account.disconnected")}
                                        </Typography>)
                                    }
                                </Stack>
                            </IconButton>
                        </Tooltip>
                    </Box>
                </Stack>
            </Stack>


            {/* Dialog About/Info */}
            <Dialog
                fullWidth={true}
                maxWidth={'md'}
                open={openDialogInfo}
                TransitionComponent={Transition}
                keepMounted
                onClose={handleCloseDialogInfo}
                aria-describedby="Dialog info"
            >
                <DialogTitle>
                    <Typography gutterBottom variant="h4" component="div">
                        {t("sidebar.account.title", [''])}
                    </Typography>
                </DialogTitle>
                <Divider></Divider>
                <Grid container
                      spacing={3}
                      padding={2}
                >
                    <Grid item xs={8} minWidth={'325px'}>
                        <Card elevation={0} style={{border: '1px solid #b2b2b2'}}>
                            <CardContent>
                                <Typography gutterBottom variant="h5" component="div">
                                    {t("sidebar.account.setting.title")}
                                </Typography>
                                <Grid container
                                      direction="column"
                                      justifyContent="left"
                                      alignItems="left">
                                    <Grid item>
                                        <Grid container direction="row" justifyContent={'center'} alignItems={'center'}>
                                            <Grid item xs={2}>
                                                <Typography variant="subtitle1">RTF</Typography>
                                            </Grid>
                                            <Grid item xs={10}>
                                                <FormControl component="fieldset">
                                                    <FormGroup aria-label="position" column>
                                                        <FormControlLabel
                                                            value="0"
                                                            disabled={true}
                                                            control={<Switch color="primary"/>}
                                                        />
                                                    </FormGroup>
                                                </FormControl>
                                            </Grid>
                                        </Grid>
                                    </Grid>
                                    <Grid item>
                                        <Grid container direction="row" justifyContent={'center'} alignItems={'center'}>
                                            <Grid item xs={2}>
                                                <Typography
                                                    variant="subtitle1">{t("sidebar.account.setting.langugage")}</Typography>
                                            </Grid>
                                            <Grid item xs={10}>
                                                <Select
                                                    value={currentLanguage}
                                                    onChange={(event) => setLanguage(event.target.value)}
                                                    fullWidth
                                                >
                                                    {availableLanguages.map((code) => (
                                                        <MenuItem key={code} value={code}>
                                                            {LANGUAGE_LABELS[code] || code}
                                                        </MenuItem>
                                                    ))}
                                                </Select>
                                            </Grid>
                                        </Grid>
                                    </Grid>
                                </Grid>
                                <Grid item>
                                    <Grid container direction="row" justifyContent={'center'} alignItems={'center'}>
                                        <Grid item xs={2}>
                                            <Typography
                                                variant="subtitle1">{t("sidebar.account.setting.theme")}</Typography>
                                        </Grid>
                                        <Grid item xs={10}>
                                            <FormControl>
                                                <FormLabel id="demo-theme-toggle">{t("sidebar.account.setting.theme")}</FormLabel>
                                                <RadioGroup
                                                    aria-labelledby="demo-theme-toggle"
                                                    name="theme-toggle"
                                                    row
                                                    value={mode}
                                                    onChange={(event) => setMode(event.target.value)}
                                                >
                                                    <FormControlLabel value="system" control={<Radio/>} label={tCommon("common.system")}/>
                                                    <FormControlLabel value="light" control={<Radio/>} label={tCommon("common.light")}/>
                                                    <FormControlLabel value="dark" control={<Radio/>} label={tCommon("common.dark")}/>
                                                </RadioGroup>
                                            </FormControl>
                                        </Grid>
                                    </Grid>
                                </Grid>

                            </CardContent>
                        </Card>
                    </Grid>
                    <Grid item xs minWidth={'200px'}>
                        <Card elevation={0} style={{border: '1px solid #b2b2b2'}}>
                            <CardContent>
                                <Box
                                    sx={{
                                        display: "flex",
                                        alignItems: "center",
                                    }}>
                                    <LinkIcon style={{color: '#FF7233'}}/>
                                    <Typography variant="h5" component="div">
                                        {t("sidebar.account.helpful_link")}
                                    </Typography>
                                </Box>
                                <List>
                                    <Button
                                        style={{
                                            width: '100%',
                                            marginTop: '10px',
                                            color: '#FF7233',
                                            borderColor: '#FF7233'
                                        }}
                                        variant="outlined"
                                        href="#outlined-buttons">
                                        {t("sidebar.account.helpful_link.shop")}
                                    </Button>
                                    <Button style={{
                                        width: '100%',
                                        marginTop: '10px',
                                        color: '#FF7233',
                                        borderColor: '#FF7233'
                                    }}
                                            variant="outlined"
                                            href="#outlined-buttons">
                                        {t("sidebar.account.helpful_link.GCU")}
                                    </Button>
                                    <Button style={{
                                        width: '100%',
                                        marginTop: '10px',
                                        color: '#FF7233',
                                        borderColor: '#FF7233'
                                    }}
                                            variant="outlined"
                                            href="#outlined-buttons">
                                        {t("sidebar.account.helpful_link.FAQ")}
                                    </Button>
                                </List>
                            </CardContent>
                        </Card>
                    </Grid>
                </Grid>
            </Dialog>

            <Dialog
                fullWidth={true}
                maxWidth={'sm'}
                open={false}
                TransitionComponent={Transition}
                keepMounted
                onClose={handleCloseDialogInfo}
                aria-describedby="Dialog profile"

            >
                <DialogTitle>
                    <Typography gutterBottom variant="h4" component="div">
                        {t('sidebar.about.title')}
                    </Typography>
                </DialogTitle>
                <Divider></Divider>

                <Card elevation={0} style={{border: '1px solid #b2b2b2'}}>
                    <CardContent>
                        <List>
                            <Button
                                style={{
                                    width: '100%',
                                    marginTop: '10px',
                                    color: '#FF7233',
                                    borderColor: '#FF7233'
                                }}
                                variant="outlined"
                                onClick={() => {
                                    // handleCloseDialogInfo()
                                    navigate('/changelog')
                                }}
                            >
                                {t('sidebar.about.version_note')}
                            </Button>
                            <Button style={{
                                width: '100%',
                                marginTop: '10px',
                                color: '#FF7233',
                                borderColor: '#FF7233'
                            }}
                                    variant="outlined"
                                    href="#outlined-buttons">
                                {t('sidebar.about.documentation')}
                            </Button>
                            <Button style={{
                                width: '100%',
                                marginTop: '10px',
                                color: '#FF7233',
                                borderColor: '#FF7233'
                            }}
                                    variant="outlined"
                                    href="#outlined-buttons">
                                {t('sidebar.about.GCU')}
                            </Button>
                        </List>
                    </CardContent>
                </Card>

                <DialogActions sx={{
                    justifyContent: 'flex-start'
                }}>
                    {/*{t('sidebar.about.version', [_licenceContext.allInfo.version])}*/}
                </DialogActions>
            </Dialog>

            <Dialog open={openDialogDisconnect} fullWidth={true} width={'md'}
            onClose={handleCloseDialogDisconnect}
            >
                <DialogTitle>
                    <Typography gutterBottom variant="h4" component="div">
                        {t('sidebar.account.disconnected.title')}
                    </Typography>

                </DialogTitle>
                <DialogContent>
                    <Typography gutterBottom component="div">
                        {t('sidebar.account.disconnected.question')}
                    </Typography>
                </DialogContent>
                <DialogActions>
                    <Button className={'Md-Button-color'} onClick={()=>{
                        _tokenContext.disconnect()
                        // window.location.href = 'https://security.alais-studio.fr/auth/disconnect'
                    }}>{tCommon('common.yes')}</Button>
                    <Button className={'Md-Button-color'} onClick={handleCloseDialogDisconnect}>{tCommon('common.no')}</Button>
                </DialogActions>
            </Dialog>

        </>
    )
}